import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function addRegistration(params) {
	return client.post("unilevel/registration", params, {
		header: {
			'Content-Type': 'multipart/form-data'
		}
	});
}

export default {
	addRegistration
};